import { render } from "./Slogan6.vue?vue&type=template&id=4c49dbfe&scoped=true&lang=true"
import script from "./Slogan6.vue?vue&type=script&lang=js"
export * from "./Slogan6.vue?vue&type=script&lang=js"

import "./Slogan6.vue?vue&type=style&index=0&id=4c49dbfe&lang=css&scoped=true"

import exportComponent from "C:\\Users\\dev2\\Documents\\dev\\sitio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c49dbfe"]])

export default __exports__